var exports = {
  "f0": "xfd349460--eba101--labels-layout",
  "Pf": "xfd349460--eba101--label",
};

module.exports = exports;
